import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setDrawer } from 'slices/drawer'
import { Button } from 'components/button'
import { FIREBASE_EVENTS } from 'app-constants'
import { useFirebaseEvent } from 'hooks'
import { UNCOMPLETED_OBJECTION_DESCRIPTION } from '../../constants'
import './style.scss'

export function ObjectionDetail() {
  const { contractObjection } = useSelector(({ contract: { objection } }) => ({
    contractObjection: objection,
  }))
  const { ticketId, complete, completionDetails } = contractObjection
  const dispatch = useDispatch()
  const { sendEvent } = useFirebaseEvent()

  useEffect(() => {
    sendEvent(FIREBASE_EVENTS.OBJECTION_DETAIL)
  }, [sendEvent])

  function handleClick() {
    dispatch(setDrawer(''))
  }

  function getDescription() {
    const descriptionText = complete ? completionDetails.message : UNCOMPLETED_OBJECTION_DESCRIPTION

    return descriptionText
  }

  function getResult() {
    if (complete)
      return <span className='description'>Resultado da conclusão: {completionDetails.result}</span>

    return null
  }

  return (
    <div className='container-detail'>
      <span className='title'>Contestação</span>
      <div className='container-protocol'>
        <span className='protocol'>
          <strong>Protocolo N°</strong> {ticketId}
        </span>
      </div>
      <div className='container-description'>
        {getResult()}
        <span className='description'>{getDescription()}</span>
      </div>
      <div className='container-buttom'>
        <Button color='primary' className='button' onClick={handleClick}>
          Ok, entendi!
        </Button>
      </div>
    </div>
  )
}
